import {State} from '../types'

export const getCalendarLinks = (state: State) => state.calendarLinks || state.event.calendarLinks
